import { Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import posthog from 'posthog-js';
import SmallModal from '../global/SmallModal';
import useSwitchToFreePlan from '../../hooks/subscriptions/useSwitchToFreePlan';
import useGetSubscription from '../../hooks/subscriptions/useGetSubscription';
import useUser from '../../hooks/global/useUser';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  cancel: {
    action: () => void | Promise<void>;
    isLoading?: boolean;
  };
}

function FreeSubscriptionModal({ isOpen, onClose, cancel }: Props) {
  const { user } = useUser();
  const { data: subscription } = useGetSubscription();

  const {
    mutate: switchToFreePlan,
    isPending,
    isSuccess,
  } = useSwitchToFreePlan({
    onSuccess: () => {
      posthog.capture('user_kept_plan_free', {
        business_id: user?.business?.id,
      });

      window.location.reload();
    },
  });

  if (!subscription?.subscription || !user?.business) return null;

  return (
    <SmallModal open={isOpen} onClose={onClose}>
      <Stack p={2}>
        <Typography variant="h3">
          Thinking of cancelling? What if you could keep your plan — for free?
        </Typography>
        <br />
        <Typography variant="body2">
          We get it, but before you go, here&apos;s another option. Keep your
          Porter plan 100% free. you&apos;ll still get all the features you use
          today — bookings, payments, messaging, and more. You also won&apos;t
          pay any credit card fees.
          <br />
          <br />
          How? We&apos;ll simply pass a small 10% processing fee to your clients
          at checkout (instead of charging you monthly). No hidden fees. No
          changes to your workflow. Just a smarter way to keep everything
          running.
          <br />
          <br />
          <Typography variant="inherit" component="span" fontWeight={600}>
            It&apos;s free for you. Still seamless for your clients.
          </Typography>
          <br />
          <br />
          👉 Stay on for free, or cancel below.
        </Typography>
      </Stack>
      <Stack
        borderTop={theme =>
          `0.5px solid ${theme.palette.lightOutlineGrey.main}`
        }
        direction="row"
        justifyContent="space-between"
        p={2}
        gap={1}>
        <LoadingButton
          variant="light"
          color="info"
          onClick={cancel.action}
          loading={cancel.isLoading}>
          <span>Cancel Anyway</span>
        </LoadingButton>
        <LoadingButton
          variant="base"
          color="primary"
          onClick={() =>
            switchToFreePlan({
              subscriptionId: subscription.subscription!.id,
              businessId: user.business.id,
            })
          }
          loading={isPending}
          disabled={isSuccess}>
          <span>Keep My Plan Free</span>
        </LoadingButton>
      </Stack>
    </SmallModal>
  );
}

export default FreeSubscriptionModal;
